// src/components/services/ServicesCTASection.jsx
import React from "react";
import { Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ServicesCTASection = () => {
  const navigate = useNavigate();

  const ctaStyle = {
    backgroundColor: "#000000",
    color: "white",
    textAlign: "center",
    padding: "4rem 0",
  };

  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 1.5rem",
  };

  const buttonStyle = {
    background: "linear-gradient(45deg, #0891b2, #22d3ee)",
    color: "white",
    padding: "1rem 2.5rem",
    border: "none",
    borderRadius: "8px",
    fontSize: "1.1rem",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "all 0.3s ease",
    textTransform: "uppercase",
    letterSpacing: "1px",
  };

  return (
    <section style={ctaStyle}>
      <div style={containerStyle}>
        <h2
          style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            marginBottom: "1rem",
          }}
        >
          Ready to Upgrade Your Equipment?
        </h2>
        <p
          style={{
            fontSize: "1.25rem",
            color: "#e0e0e0",
            marginBottom: "2rem",
          }}
        >
          Contact us today to schedule your service or get a custom quote
        </p>
        <button
          style={buttonStyle}
          onMouseOver={(e) => (e.target.style.transform = "translateY(-2px)")}
          onMouseOut={(e) => (e.target.style.transform = "translateY(0)")}
          onClick={() => navigate("/contact")}
        >
          <Phone
            size={18}
            style={{ marginRight: "0.5rem", display: "inline" }}
          />
          Contact Us Today
        </button>
      </div>
    </section>
  );
};

export default ServicesCTASection;
